import React from 'react';
import styled from "styled-components";

import {RowDiv} from "../../components/styledComponents/CustomStyledComponents";

const ChildrenWrapper = styled.div`
    height: 100%;
    flex: 1 1 auto;
`;

const HomeComponent: React.FC = ({children}) => {
    return (
        <RowDiv style={{height: '100%'}}>
            <ChildrenWrapper id='ChildrenWrapper'>
                {children}
            </ChildrenWrapper>
        </RowDiv>

    );
};

export default HomeComponent;
